<template>
  <div style="height: 100%;">
    <page v-if="$route.path === '/home/method'">
      <ZuiHeader/>
      <SubPageTemplate page-title="攻略推荐" :pid="$cid.home.gongLueTuiJian" :page-size="6"
                       type="article"
                       :video-mask="false" @article-click="articleClick"></SubPageTemplate>
      <ZuiFooter/>
    </page>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import SubPageTemplate from "~/components/template/SubPageTemplate.vue";

export default {
  components: {
    SubPageTemplate
  },
  data() {
    return {
      pid: null,
      tabId: ''
    }
  },
  created() {
    this.tabId = this.$route.query.id;
  },
  methods: {
    articleClick(item) {
      this.$openNewWindow('/new/home/method/info?id=' + item.id);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/homePage/method.vue